import React from 'react';
import { SEMANTIC, UI } from '../../styles/theme';

const ICONS = {
  success: { icon: 'bi-check-circle-fill', color: 'var(--sem-action-buy)' },
  error:   { icon: 'bi-x-circle-fill',     color: 'var(--sem-action-sell)' },
  info:    { icon: 'bi-info-circle-fill',   color: 'var(--sem-cta-primary)' },
  confirm: { icon: 'bi-lightning-charge-fill', color: 'var(--sem-cta-primary)' },
  warning: { icon: 'bi-exclamation-triangle-fill', color: 'var(--sem-action-hold)' },
};

/**
 * AppModal — modale in-app, sostituisce alert() e confirm().
 *
 * Props:
 *  type        'success' | 'error' | 'info' | 'confirm' | 'warning'
 *  title       testo principale
 *  message     testo secondario (opzionale)
 *  onClose     callback pulsante OK / Annulla / clic esterno
 *  onConfirm   se presente, mostra due pulsanti (Annulla + Conferma)
 *  confirmLabel testo pulsante conferma  (default 'OK')
 *  cancelLabel  testo pulsante annulla   (default 'Annulla')
 */
const AppModal = ({
  type = 'info',
  title,
  message,
  onClose,
  onConfirm,
  confirmLabel = 'OK',
  cancelLabel = 'Annulla',
}) => {
  const { icon, color } = ICONS[type] || ICONS.info;
  const isConfirm = !!onConfirm;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        backgroundColor: 'rgba(0,0,0,0.72)',
        backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: UI.spacing.lg,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          backgroundColor: SEMANTIC.backgroundCard,
          borderRadius: UI.borderRadius.lg,
          border: `1px solid ${color}44`,
          boxShadow: `0 0 40px ${color}22`,
          padding: '32px 28px',
          maxWidth: '400px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: UI.spacing.lg,
        }}
      >
        {/* Icona */}
        <div style={{
          width: '56px', height: '56px', borderRadius: '50%',
          backgroundColor: `${color}18`,
          border: `2px solid ${color}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <i className={`bi ${icon}`} style={{ fontSize: '24px', color }} />
        </div>

        {/* Testi */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: UI.spacing.sm }}>
          {title && (
            <h3 style={{ color: SEMANTIC.textPrimary, fontSize: UI.fontSize.xl, fontWeight: UI.fontWeight.bold, margin: 0 }}>
              {title}
            </h3>
          )}
          {message && (
            <p style={{ color: SEMANTIC.textSecondary, fontSize: UI.fontSize.md, margin: 0, lineHeight: '1.6' }}>
              {message}
            </p>
          )}
        </div>

        {/* Pulsanti */}
        <div style={{ display: 'flex', gap: UI.spacing.md, width: '100%' }}>
          {isConfirm && (
            <button
              onClick={onClose}
              style={{
                flex: 1, padding: UI.spacing.md,
                backgroundColor: 'transparent',
                border: '2px solid rgba(255,255,255,0.18)',
                borderRadius: UI.borderRadius.pill,
                color: SEMANTIC.textSecondary,
                fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold,
                cursor: 'pointer',
              }}
            >
              {cancelLabel}
            </button>
          )}
          <button
            onClick={isConfirm ? onConfirm : onClose}
            style={{
              flex: 1, padding: UI.spacing.md,
              backgroundColor: color,
              border: 'none',
              borderRadius: UI.borderRadius.pill,
              color: type === 'success' || type === 'confirm' ? SEMANTIC.ctaPrimaryText : '#fff',
              fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold,
              cursor: 'pointer',
            }}
          >
            {isConfirm ? confirmLabel : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppModal;
